export const getItemFromLocalStorage = (itemKey) => {
  if (itemKey) {
    return window.localStorage.getItem(itemKey);
  }

  return null;
};

/**
 * Get the authentication strategy type from localStorage
 * @returns {string|null} 'keycloak' | 'hybrid' | null
 */
export const getStrategyType = () => {
  return getItemFromLocalStorage('strategyType');
};

/**
 * Clear all authentication-related localStorage and sessionStorage items
 * This should be called when user authentication fails or during logout
 * @param {boolean} keepErrorMessage - Whether to preserve error messages for display
 */
export const clearAuthenticationStorage = (keepErrorMessage = false) => {
  // Store error message if it exists and we want to keep it
  const errorMessage = keepErrorMessage
    ? localStorage.getItem('auth_error_message')
    : null;

  // Remove all authentication-related localStorage items
  localStorage.removeItem('id_token');
  localStorage.removeItem('username');
  localStorage.removeItem('userName');
  localStorage.removeItem('notification-status');
  localStorage.removeItem('roleCode');
  localStorage.removeItem('productId');
  localStorage.removeItem('strategyType');

  // Clear all sessionStorage (since it may contain authentication-related data)
  sessionStorage.clear();

  // Restore error message if we want to keep it
  if (keepErrorMessage && errorMessage) {
    localStorage.setItem('auth_error_message', errorMessage);
  }
};
